/* ========== ~~~~~~~~~~ REWARDS STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const AWARD_POINTS = 'AWARD_POINTS';
export const REPLACE_POINTS_EARNED = 'REPLACE_POINTS_EARNED';
export const ADD_REWARDS = 'ADD_REWARDS';
export const SET_POINTS_FOR_CURRENT_MR_PROVIDER = 'SET_POINTS_FOR_CURRENT_MR_PROVIDER';
export const AWARD_POINTS_WITH_REWARDS = 'AWARD_POINTS_WITH_REWARDS';
export const RESET_POINTS_BAR = 'RESET_POINTS_BAR';
export const PERMIT_REWARDS = 'PERMIT_REWARDS';
// export const REMOVE_EXPANDED_MESSAGE = 'REMOVE_EXPANDED_MESSAGE';

export const awardPoints = numberOfPoints => ({
    type: AWARD_POINTS,
    numberOfPoints
});
export const replacePointsEarned = newPointsEarnedValue => ({
    type: REPLACE_POINTS_EARNED,
    newPointsEarnedValue
});
export const addRewards = numberOfRewards => ({
    type: ADD_REWARDS,
    numberOfRewards
});
export const setPointsForCurrentMRProvider = (contentId, provider, points) => ({
    type: SET_POINTS_FOR_CURRENT_MR_PROVIDER,
    contentId,
    provider,
    points
});

// export const awardPointsWithRewards = (numberOfPoints, numberOfRewards, showExpandedMessage) => ({
//     type: AWARD_POINTS_WITH_REWARDS,
//     numberOfPoints,
//     numberOfRewards,
//     showExpandedMessage
// });
export const awardPointsWithRewards = (numberOfPoints, numberOfRewards, rewardsPhase) => ({
    type: AWARD_POINTS_WITH_REWARDS,
    numberOfPoints,
    numberOfRewards,
    rewardsPhase
});
export const resetPointsBar = () => ({
    type: RESET_POINTS_BAR
});
export const permitRewards = () => ({
    type: PERMIT_REWARDS
});
